export default {
  beforeCreate () {
    this.$log.info('version: 0.40')
  }
}
